import { useState } from "react";

export const DiscardChangesModal = ({ onConfirm, onCancel }) => {
    return (
        <div className="tw-fixed tw-gap-4 tw-z-[9999] tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-black/50">
            <div className="tw-bg-white tw-p-6 tw-rounded-lg tw-shadow-lg tw-text-center">
                <p className="tw-mb-4 tw-text-lg tw-font-semibold">Are you sure you want to discard changes?</p>
                <p className="tw-text-gray-500 tw-mb-4">Unsaved changes will be lost.</p>
                <div className="tw-flex tw-justify-center tw-gap-4">
                    <button onClick={onConfirm} className="tw-bg-red-500 tw-text-white tw-px-4 tw-py-2 tw-rounded">
                        Discard
                    </button>
                    <button onClick={onCancel} className="tw-bg-gray-300 tw-text-black tw-px-4 tw-py-2 tw-rounded">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};
